import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "schedule-loading"
};
const _hoisted_2 = {
  key: 1,
  class: "schedule-list"
};
const _hoisted_3 = {
  class: "event-row d-none d-md-flex"
};
const _hoisted_4 = {
  class: "event-left"
};
const _hoisted_5 = {
  class: "event-title-row"
};
const _hoisted_6 = {
  key: 0,
  class: "live-badge"
};
const _hoisted_7 = {
  class: "event-title"
};
const _hoisted_8 = {
  class: "event-meta-group"
};
const _hoisted_9 = {
  class: "event-meta"
};
const _hoisted_10 = {
  class: "event-meta"
};
const _hoisted_11 = ["href"];
const _hoisted_12 = {
  class: "event-right"
};
const _hoisted_13 = ["href"];
const _hoisted_14 = ["href"];
const _hoisted_15 = {
  class: "event-mobile d-md-none"
};
const _hoisted_16 = {
  class: "event-mobile-top"
};
const _hoisted_17 = {
  key: 0,
  class: "live-badge"
};
const _hoisted_18 = ["href"];
const _hoisted_19 = {
  class: "event-title mobile-title"
};
const _hoisted_20 = {
  class: "event-meta-group"
};
const _hoisted_21 = {
  class: "event-meta"
};
const _hoisted_22 = {
  class: "event-meta"
};
const _hoisted_23 = ["href"];
const _hoisted_24 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_b_container = _resolveComponent("b-container");
  return _openBlock(), _createBlock(_component_b_container, {
    fluid: "",
    class: "schedule-list-wrap"
  }, {
    default: _withCtx(() => [_ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_spinner), _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "schedule-loading-copy"
    }, [_createElementVNode("strong", null, "Loading Premieres"), _createElementVNode("span", null, "Please wait while we fetch upcoming premieres.")], -1))])) : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.premieres, premiere => {
      return _openBlock(), _createElementBlock("div", {
        key: premiere.id,
        class: "event-card"
      }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [+premiere.islive === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[1] || (_cache[1] = [_createElementVNode("span", {
        class: "live-dot"
      }, null, -1), _createTextVNode(" Live ", -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, _toDisplayString(premiere.name), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "event-meta-icon"
      }, "🗓", -1)), _createElementVNode("span", null, "Start: " + _toDisplayString(premiere.streamdatefull) + " — " + _toDisplayString(premiere.streamtimefull), 1)]), _createElementVNode("div", _hoisted_10, [_cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "event-meta-icon"
      }, "🗓", -1)), _createElementVNode("span", null, "End: " + _toDisplayString(premiere.enddatefull) + " — " + _toDisplayString(premiere.endtimefull), 1)])]), _withDirectives(_createElementVNode("a", {
        href: premiere.programlink,
        class: "event-program-link",
        target: "_blank"
      }, " Event Program ", 8, _hoisted_11), [[_vShow, premiere.programlink && premiere.programlink !== '']])]), _createElementVNode("div", _hoisted_12, [+premiere.islive === 1 ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: "watch-btn",
        href: premiere.livehref
      }, " Watch Now ", 8, _hoisted_13)) : _createCommentVNode("", true), _createElementVNode("a", {
        class: "channel-pill",
        href: '/video/channel/' + premiere.networkchannel_id
      }, _toDisplayString(premiere && premiere.networkchannel && premiere.networkchannel.name ? premiere.networkchannel.name : 'Channel'), 9, _hoisted_14)])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [+premiere.islive === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[4] || (_cache[4] = [_createElementVNode("span", {
        class: "live-dot"
      }, null, -1), _createTextVNode(" Live ", -1)]))])) : _createCommentVNode("", true), _createElementVNode("a", {
        class: "channel-pill",
        href: '/video/channel/' + premiere.networkchannel_id
      }, _toDisplayString(premiere && premiere.networkchannel && premiere.networkchannel.name ? premiere.networkchannel.name : 'Channel'), 9, _hoisted_18)]), _createElementVNode("div", _hoisted_19, _toDisplayString(premiere.name), 1), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_cache[5] || (_cache[5] = _createElementVNode("span", {
        class: "event-meta-icon"
      }, "🗓", -1)), _createElementVNode("span", null, "Start: " + _toDisplayString(premiere.streamdatefull) + " — " + _toDisplayString(premiere.streamtimefull), 1)]), _createElementVNode("div", _hoisted_22, [_cache[6] || (_cache[6] = _createElementVNode("span", {
        class: "event-meta-icon"
      }, "🗓", -1)), _createElementVNode("span", null, "End: " + _toDisplayString(premiere.enddatefull) + " — " + _toDisplayString(premiere.endtimefull), 1)])]), _withDirectives(_createElementVNode("a", {
        href: premiere.programlink,
        class: "event-program-link",
        target: "_blank"
      }, " Event Program ", 8, _hoisted_23), [[_vShow, premiere.programlink && premiere.programlink !== '']]), +premiere.islive === 1 ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: premiere.livehref,
        class: "watch-btn mobile-watch-btn"
      }, " Watch Now ", 8, _hoisted_24)) : _createCommentVNode("", true)])]);
    }), 128))], 512)), [[_vShow, !_ctx.collapsed || !$props.collapseable]])], undefined, true),
    _: 1
  });
}